import React from "react";
import { Link } from "react-router-dom";
import "./styles/PolicyPages.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <p className="policy-updated">Last updated: March 2026</p>

        <section className="policy-section">
          <h2>Introduction</h2>
          <p>VyralNews ("we," "us," or "our"), operated by Vyral Media Group, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <strong>vyralnews.com</strong> or use our mobile application. Please read this policy carefully. If you disagree with its terms, please discontinue use of our services.</p>
        </section>

        <section className="policy-section">
          <h2>Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><strong>Account Information</strong> – When you register, we collect your username, email address, and password.</li>
            <li><strong>Payment Information</strong> – Subscription payments are processed through Stripe. We do not store your credit card details on our servers. Stripe may collect and store payment data per their own privacy policy.</li>
            <li><strong>Usage Data</strong> – We track articles you read, pages you visit, and features you use to improve our service and apply freemium access limits.</li>
            <li><strong>IP Address</strong> – We collect IP addresses for rate limiting, security purposes, and tracking free article usage for non-logged-in visitors.</li>
            <li><strong>Device Information</strong> – When using our mobile app, we may collect device type, operating system, and app version information.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Create and manage your account</li>
            <li>Process subscription payments and send billing notifications</li>
            <li>Enforce freemium article access limits</li>
            <li>Personalize your experience on VyralNews</li>
            <li>Send you service-related emails (account confirmations, subscription updates)</li>
            <li>Monitor and analyze usage to improve our platform</li>
            <li>Detect and prevent fraudulent activity and abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Cookies and Tracking</h2>
          <p>We use browser local storage and session data to keep you logged in and remember your preferences (such as your selected local news region). We do not currently use third-party advertising trackers or behavioral advertising cookies.</p>
        </section>

        <section className="policy-section">
          <h2>How We Share Your Information</h2>
          <p>We do not sell your personal information. We may share your information only in the following circumstances:</p>
          <ul>
            <li><strong>Stripe</strong> – For payment processing. Stripe operates under its own privacy policy.</li>
            <li><strong>Infura / IPFS</strong> – For media file storage when content is uploaded by staff.</li>
            <li><strong>Legal Requirements</strong> – If required by law, regulation, or valid legal process.</li>
            <li><strong>Business Transfer</strong> – In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Data Retention</h2>
          <p>We retain your account information for as long as your account is active. If you request account deletion, we will remove your personal data within 30 days, except where retention is required by law or for legitimate business purposes such as fraud prevention.</p>
        </section>

        <section className="policy-section">
          <h2>Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and personal data</li>
            <li>Opt out of marketing communications</li>
          </ul>
          <p>To exercise any of these rights, contact us at <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a>.</p>
        </section>

        <section className="policy-section">
          <h2>Security</h2>
          <p>We implement industry-standard security measures including password hashing, JWT-based authentication, HTTPS encryption, and rate limiting to protect your account. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>
        </section>

        <section className="policy-section">
          <h2>Children's Privacy</h2>
          <p>VyralNews is not directed at children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us and we will delete it promptly.</p>
        </section>

        <section className="policy-section">
          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by updating the "Last updated" date at the top of this page. Continued use of VyralNews after changes are posted constitutes your acceptance of the updated policy.</p>
        </section>

        <section className="policy-section">
          <h2>Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact us at:<br />
          <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a><br />
          Vyral Media Group</p>
        </section>

        <div className="policy-links">
          <Link to="/terms">Terms of Service</Link>
          <Link to="/payment-policy">Payment Policy</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
